module.exports = __webpack_public_path__ + "img/work2.9f714445.gif";